import React from 'react';

function About() {
  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '50px auto', 
      padding: '40px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333',
      textAlign: 'left',
      background: '#fff',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      borderRadius: '8px'
    }}>
      <h1 style={{ color: '#667eea', marginBottom: '10px' }}>About LaTeXLab</h1>
      <p style={{ color: '#64748b', marginBottom: '30px', fontSize: '18px' }}>
        A simple, powerful LaTeX editor built for students, researchers, and academics.
      </p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Our Mission</h2>
      <p>
        LaTeXLab was created to make academic writing easier and more accessible. We believe that 
        powerful tools for creating professional documents should be free and easy to use.
      </p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>What We Offer</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>28+ professional templates for journals, conferences, theses, and resumes</li>
        <li style={{ marginBottom: '8px' }}>Real-time PDF compilation with instant preview</li>
        <li style={{ marginBottom: '8px' }}>Multi-file project support with folders</li>
        <li style={{ marginBottom: '8px' }}>Easy image conversion (PNG, PDF, EPS)</li>
        <li style={{ marginBottom: '8px' }}>Upload and work with existing LaTeX projects</li>
        <li style={{ marginBottom: '8px' }}>Download projects as ZIP for backup</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Why LaTeXLab?</h2>
      <p>
        <strong>Free & Open:</strong> No hidden costs, no paywalls. Built by researchers, for researchers.
      </p>
      <p>
        <strong>Privacy First:</strong> Your documents are yours. We don't read them, sell them, or share them.
      </p>
      <p>
        <strong>Simple to Use:</strong> Start writing immediately with professional templates. No LaTeX installation required.
      </p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Current Status</h2>
      <p>
        LaTeXLab is currently in <strong>BETA</strong>. We're actively improving based on user feedback. 
        If you encounter any issues or have suggestions, please use the Feedback button.
      </p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Get In Touch</h2>
      <p>
        Have questions or feedback? Use the Feedback button in the app or email us at support@latexlab.com
      </p>
      
      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #e2e8f0', textAlign: 'center' }}>
        <a href="/" style={{ color: '#667eea', textDecoration: 'none', marginRight: '20px' }}>← Back to Home</a>
        <a href="/register" style={{ 
          background: '#667eea', 
          color: 'white', 
          padding: '10px 20px', 
          borderRadius: '6px', 
          textDecoration: 'none',
          display: 'inline-block'
        }}>Get Started Free →</a>
      </div>
    </div>
  );
}

export default About;
